module.exports = __webpack_public_path__ + "static/img/s42.dc2415f3.png";